export const FETCH_VENUES_SUCCESS = 'FETCH_VENUES_SUCCESS'
export const FETCH_VENUES_START = 'FETCH_VENUES_START'
export const FETCH_VENUES_ERROR = 'FETCH_VENUES_ERROR'
export const DISABLE_VENUE = 'DISABLE_VENUE'
